import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Ripple } from 'primereact/ripple';

export const BottomNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        { label: 'Courses', icon: 'pi pi-car', path: '/chauffeur/courses' },
        { label: 'Effectuées', icon: 'pi pi-check-circle', path: '/chauffeur/effectue' },
        { label: 'Compte', icon: 'pi pi-user', path: '/chauffeur/compte' }
    ];

    return (
        <div className="fixed  bottom-0 left-0 right-0 bg-white px-2 pb-2 pt-1 flex justify-content-around align-items-center" 
             style={{ zIndex: 2000, height: '50px', borderTop: '1px solid #e2e8f0' }}>
            
            {menuItems.map((item) => {
                const isActive = location.pathname.startsWith(item.path);

                return (
                    <div 
                        key={item.label}
                        onClick={() => navigate(item.path)}
                        className={`p-ripple flex flex-column align-items-center justify-content-center cursor-pointer p-2 border-round-xl transition-all transition-duration-300 
                            ${isActive ? 'text-blue-600 bg-blue-50' : 'text-500 hover:bg-gray-100'}`}
                        style={{ width: '75px', position: 'relative' }}
                    >
                        <i className={`${item.icon} ${isActive ? 'text-xl' : 'text-lg'} mb-1`}></i>
                        <span className={`text-xs ${isActive ? 'font-bold' : 'font-medium'}`}>
                            {item.label}
                        </span>
                        
                        <Ripple />

                        {/* Barre indicatrice animée en bas */}
                        {isActive && (
                            <div className="absolute top-0 bg-blue-600 border-round" 
                                 style={{ height: '3px', width: '30px' }}>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};